import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../common/util/redux';
import {IEvent, IGiftRedDotStatus, ITicket} from '../type';

export interface IStateGift {
  event?: IEvent;
  ticket?: ITicket;
  needRefresh: boolean;
  giftRedDotStatus: IGiftRedDotStatus;
}

const INITIAL_STATE: IStateGift = {
  event: undefined,
  ticket: undefined,
  needRefresh: false,
  giftRedDotStatus: {
    hasEventRedDot: false,
    hasTicketRedDot: false,
  },
};

export default createReducer<IStateGift, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
    }),
    [ActionType.SetReceivedTicket]: (state, action) => {
      const {ticketId} = action.payload;
      const ticket = state.ticket?.items?.find(
        ticket => ticket.id === ticketId
      );

      if (ticket) {
        ticket.isComplete = true;
        ticket.content.bgColorRgb = 'var(--grey-08)';
      }
    },
    [ActionType.RemoveExpiredTicket]: (state, action) => {
      const {ticketId} = action.payload;
      if (state.ticket) {
        state.ticket.items = state.ticket.items?.filter(
          ticket => ticket.id !== ticketId
        );
      }
    },
  }
);
